module.exports = __webpack_public_path__ + "static/img/ai.3ac37cbb.gif";